import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';

const ROLE_TILE_COUNT: number = 6;

const FieldSkeleton = ({
  labelWidth,
  inputHeight = '3.6rem',
}: {
  labelWidth: string;
  inputHeight?: string;
}) => (
  <div>
    <div style={{ marginBottom: '0.5rem' }}>
      <Skeleton variant="text" width={labelWidth} />
    </div>
    <Skeleton variant="rect" width="100%" height={inputHeight} />
  </div>
);

const ContactFormSkeleton = () => (
  <div
    style={{
      minHeight: '100%',
      padding: '1rem 0.25rem',
    }}
  >
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gap: '2.5rem',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5rem',
        }}
      >
        <Skeleton variant="text" width="14rem" height="1.8rem" />

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '1rem',
          }}
        >
          <FieldSkeleton labelWidth="6rem" />
          <FieldSkeleton labelWidth="6rem" />
        </div>

        <FieldSkeleton labelWidth="4rem" />

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
          }}
        >
          <Skeleton variant="rect" width="1.6rem" height="1.6rem" />
          <Skeleton variant="text" width="13rem" />
        </div>

        <FieldSkeleton labelWidth="9rem" />

        <div>
          <div style={{ marginBottom: '0.5rem' }}>
            <Skeleton variant="text" width="9rem" />
          </div>
          <Skeleton variant="rect" width="100%" height="6rem" />
        </div>

        <FieldSkeleton labelWidth="9rem" />
        <FieldSkeleton labelWidth="6rem" />

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr',
            gap: '1rem',
          }}
        >
          <FieldSkeleton labelWidth="3rem" />
          <FieldSkeleton labelWidth="5rem" />
          <FieldSkeleton labelWidth="7rem" />
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5rem',
        }}
      >
        <Skeleton variant="text" width="5rem" height="1.8rem" />

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
            gap: '0.75rem',
          }}
        >
          {Array.from({ length: ROLE_TILE_COUNT }, (_, index: number) => (
            <Skeleton
              key={`contact-form-role-skeleton-${index}`}
              variant="rect"
              width="100%"
              height="5.25rem"
            />
          ))}
        </div>

        <FieldSkeleton labelWidth="11rem" />
        <FieldSkeleton labelWidth="8rem" />

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
          }}
        >
          <Skeleton variant="rect" width="1.6rem" height="1.6rem" />
          <Skeleton variant="text" width="14rem" />
        </div>
      </div>
    </div>
  </div>
);

export default ContactFormSkeleton;
